//

const SUBJECT_NAMES = {
  ancientAdventures: 'ancient-adventures',
  beginningCoders: 'beginning-coders',
  brainteasers: 'brainteasers',
  camp: 'camp',
  chessMasters: 'chess-masters',
  chineseLanguageAndTravel: 'chinese-language-and-travel',
  club: 'club',
  cosmicAdventures: 'cosmic-adventures',
  creativeWriting: 'creative-writing',
  curiousWorld: 'curious-world',
  digitalPhotography: 'digital-photography',
  dinoDiscovery: 'dinosaur-discovery',
  drama: 'drama',
  englishLanguageArts: 'englishLanguageArts',
  juniorGeologists: 'junior-geologists',
  magic: 'magic',
  math: 'math',
  mathletics: 'mathletics',
  moneyMatters: 'money-matters',
  roblox: 'roblox',
  science: 'science',
  scienceFiction: 'science-fiction',
  sketchmasters: 'sketchmasters',
  spanishLanguageAndTravel: 'spanish-language-and-travel',
  sportsAnalytics: 'sports-analytics',
  teachRock: 'teachrock',
  theater: 'theater',
  weatherWonders: 'weather-wonders',
  wildlifeCreatures: 'wildlife-creatures',
  writing: 'writing',
  youngAnimators: 'young-animators',
};

const SUBJECT_SEARCH_PATTERNS = [
  // Single-subject/specific patterns first
  {
    name: SUBJECT_NAMES.ancientAdventures,
    pattern: /ancient[- ]adventure/i,
  },
  {
    name: SUBJECT_NAMES.beginningCoders,
    pattern: /beginning[- ]coder/i,
  },
  {
    name: SUBJECT_NAMES.brainteasers,
    pattern: /brainteaser/i,
  },
  {
    name: SUBJECT_NAMES.chessMasters,
    pattern: /chess[- ]master/i,
  },
  {
    name: SUBJECT_NAMES.chineseLanguageAndTravel,
    pattern: /chinese[- ]language[- ](and|&)[- ]travel/i,
  },
  {
    name: SUBJECT_NAMES.cosmicAdventures,
    pattern: /cosmic[- ]adventure/i,
  },
  {
    name: SUBJECT_NAMES.creativeWriting,
    pattern: /creative[- ]writing/i,
  },
  {
    name: SUBJECT_NAMES.curiousWorld,
    pattern: /curious[- ]world/i,
  },
  {
    name: SUBJECT_NAMES.digitalPhotography,
    pattern: /digital[- ]photography/i,
  },
  {
    name: SUBJECT_NAMES.dinoDiscovery,
    pattern: /dinosaur[- ]discovery/i,
  },
  {
    name: SUBJECT_NAMES.drama,
    pattern: /drama/i,
  },
  {
    name: SUBJECT_NAMES.juniorGeologists,
    pattern: /junior[- ]geologists/i,
  },
  {
    name: SUBJECT_NAMES.magic,
    pattern: /magic/i,
  },
  {
    name: SUBJECT_NAMES.mathletics,
    pattern: /mathletics/i,
  },
  {
    name: SUBJECT_NAMES.moneyMatters,
    pattern: /money[- ]matters/i,
  },
  {
    name: SUBJECT_NAMES.roblox,
    pattern: /roblox/i,
  },
  {
    name: SUBJECT_NAMES.scienceFiction,
    pattern: /science[- ]fiction/i,
  },
  {
    name: SUBJECT_NAMES.sketchmasters,
    pattern: /sketchmasters/i,
  },
  {
    name: SUBJECT_NAMES.spanishLanguageAndTravel,
    pattern: /spanish[- ]language[- ](and|&)[- ]travel/i,
  },
  {
    name: SUBJECT_NAMES.sportsAnalytics,
    pattern: /sports[- ]analytics/i,
  },
  {
    name: SUBJECT_NAMES.teachRock,
    pattern: /teachrock/i,
  },
  {
    name: SUBJECT_NAMES.theater,
    pattern: /theater/i,
  },
  {
    name: SUBJECT_NAMES.weatherWonders,
    pattern: /weather[- ]wonder/i,
  },
  {
    name: SUBJECT_NAMES.wildlifeCreatures,
    pattern: /wildlife[- ]creature/i,
  },
  {
    name: SUBJECT_NAMES.youngAnimators,
    pattern: /young[- ]animator/i,
  },

  // More generic patterns last to act as fallbacks/catch-alls
  {
    name: SUBJECT_NAMES.camp,
    pattern: /camp/i,
  },
  {
    name: SUBJECT_NAMES.club,
    pattern: /club/i,
  },
  {
    name: SUBJECT_NAMES.englishLanguageArts,
    pattern: /english|language|reading/i,
  },
  {
    name: SUBJECT_NAMES.math,
    pattern: /algebra|calculus|geometry|math|trigonometry/i,
  },
  {
    name: SUBJECT_NAMES.science,
    pattern: /biology|chemistry|physics|science/i,
  },
  {
    name: SUBJECT_NAMES.writing,
    pattern: /writing/i,
  },
];

// Exports
// -------

export { SUBJECT_NAMES, SUBJECT_SEARCH_PATTERNS };

export default SUBJECT_SEARCH_PATTERNS;
